import React from "react";

import { Navbar } from "src/components";

import styles from "./styles.module.scss";

// assets
import VirtualImg from "src/assets/images/blog/virtual.jpeg";
import BlogImg from "src/assets/images/blog/hero-img.png";
import ArrangeImg from "src/assets/images/blog/arrange.jpg";
import FindImg from "src/assets/images/blog/fing.png";

const Hero = ({ data }) => {
  console.log(data?.BlogImage);
  console.log(data?.BlogImage.replaceAll("\\", "/").replace(".com//", "/"));

  const isVirtual = () => {
    // if (data?.BlogTitle === "Best Virtual andLive Stream Events in 2020")
    //   return VirtualImg;
    // if (data?.BlogTitle === "How to Arrange events during this Lock-Down")
    //   return ArrangeImg;
    // if (
    //   data?.BlogTitle ===
    //   "How to Find Small Local Events in Your Area | Social Distancing"
    // )
    //   return FindImg;
    // if (data?.blogImage)
    // return data?.BlogImage.replaceAll("\\", "/").replace(".com//", "/");
    return data?.BlogImage;
    // return data?.BlogImage;
    // else return BlogImg;
  };

  return data ? (
    <div
      className={styles.hero__wrapper}
      style={{ backgroundImage: `url(${isVirtual()})` }}
    >
      <Navbar />
      <div className={styles.hero__text}>
        <h3>Welcome to</h3>
        <h2>Blog</h2>
      </div>
    </div>
  ) : null;
};

export default Hero;
